// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"864e84d6","239":"be0d2136","455":"de5c494d","488":"7213179a"}[chunkId] + ".chunk.js";
};